import React, { useState } from 'react';
import { Chip } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Box, Menu } from '@mui/material';
import { styled } from '@mui/system';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LockIcon from '@mui/icons-material/Lock';
const ClusterChip = styled(Chip)<{ $variant?: 'box' | 'underlined' }>(({ theme, $variant }) => ({
  backgroundColor: $variant === 'underlined' ? 'transparent' : '#f5f5f5',
  height: '40px',
  borderRadius: $variant === 'underlined' ? '0' : '4px',
  padding: '0 5px',
  boxShadow: 'none',
  fontWight: 500,
  border: $variant === 'underlined' ? 'none' : '1px solid #e0e0e0',
  borderBottom: $variant === 'underlined' ? '1px solid #e0e0e0' : 'none',
  '&.MuiChip-label': {
    paddingRight: '5px',
  },
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: $variant === 'underlined' ? '#f5f5f5' : '#eaeaea',
  },
  fontSize: $variant === 'underlined' ? '16px' : '14px',
}));

const DropdownSelect = ({
  selectedKey,
  options,
  setKey,
  isDisabled,
  freeDataKey,
  handleOnSampleClick,
  variant = 'box',
}: {
  selectedKey: any;
  options: Record<string, string>;
  setKey: React.Dispatch<React.SetStateAction<any>>;
  isDisabled: boolean;
  freeDataKey?: any;
  handleOnSampleClick?: () => void;
  variant?: 'box' | 'underlined';
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ClusterChip
        $variant={variant}
        label={options[selectedKey]}
        onClick={handleClick}
        deleteIcon={<KeyboardArrowDownIcon />}
        onDelete={handleClick}
      />
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {Object.entries(options).map(([optionKey, label]) => (
          <MenuItem
            key={optionKey}
            onClick={() => {
              if (isDisabled && optionKey !== freeDataKey) {
                handleOnSampleClick && handleOnSampleClick();
                return;
              }
              setKey(optionKey);
              handleClose();
            }}
            selected={optionKey === selectedKey}
          >
            {label as string} {isDisabled && optionKey !== freeDataKey && <LockIcon />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DropdownSelect;
